export const bankStatementsConstants = {
  BANK_STATEMENTS_REQUEST: 'BANK_STATEMENTS_REQUEST',
  BANK_STATEMENTS_SUCCESS: 'BANK_STATEMENTS_SUCCESS',
  BANK_STATEMENTS_FAILURE: 'BANK_STATEMENTS_FAILURE',
};
